import { basename } from "../Config";
function urlResolver(imageSrc) {
  if (basename === "") {
    return `/${imageSrc}`;
  }
  return `/${basename}/${imageSrc}`;
}
export default urlResolver;
